import { AdminRoute } from 'compositions/AdminRoute'
import { RootShell } from 'compositions/RootShell'
import { UnauthRoute } from 'compositions/UnauthRoute'
import { AdminAi } from 'pages/admin/ai'
import { AdminAudits } from 'pages/admin/audits'
import { AdminCapturedComms } from 'pages/admin/captured-comms'
import { AdminImports } from 'pages/admin/imports'
import { AdminInbound } from 'pages/admin/inbound'
import { AdminInboundDetail } from 'pages/admin/inbound-detail'
import { AdminInboundNew } from 'pages/admin/inbound-new'
import { AdminIntegrations } from 'pages/admin/integrations'
import { AdminSenderDetail } from 'pages/admin/sender-detail'
import { AdminSenderNew } from 'pages/admin/sender-new'
import { AdminSenders } from 'pages/admin/senders'
import { AdminTeam } from 'pages/admin/team'
import { AdminTopics } from 'pages/admin/topics'
import { CommunicationDetail } from 'pages/communications/communication-detail'
import { CommunicationList } from 'pages/communications/index'
import { SendDetail } from 'pages/communications/send-detail'
import { ContactDetail } from 'pages/contacts/contact-detail'
import { ContactImport } from 'pages/contacts/contact-import'
import { ContactNew } from 'pages/contacts/contact-new'
import { ContactList } from 'pages/contacts/index'
import { Dashboard } from 'pages/dashboard'
import { LayoutList } from 'pages/layouts/index'
import { LayoutDetail } from 'pages/layouts/layout-detail'
import { LayoutNew } from 'pages/layouts/layout-new'
import { ListIndex } from 'pages/lists/index'
import { ListDetail } from 'pages/lists/list-detail'
import { ListNew } from 'pages/lists/list-new'
import { Login } from 'pages/login'
import { Notifications } from 'pages/notifications'
import { ScheduleList } from 'pages/schedule/index'
import { ScheduleDetail } from 'pages/schedule/schedule-detail'
import { ScheduleNew } from 'pages/schedule/schedule-new'
import { SendPage } from 'pages/send/index'
import { Settings } from 'pages/settings/index'
import { TemplateList } from 'pages/templates/index'
import { TemplateDetail } from 'pages/templates/template-detail'
import { TemplateNew } from 'pages/templates/template-new'
import { createBrowserRouter, Navigate } from 'react-router'

export const router = createBrowserRouter([
  {
    path: 'login',
    element: (
      <UnauthRoute>
        <Login />
      </UnauthRoute>
    ),
  },
  {
    path: '/',
    Component: RootShell,
    children: [
      // Home lives at comms.ordo.com/ like every other app's home page;
      // /dashboard (its old address) still lands there.
      { index: true, Component: Dashboard },
      { path: 'dashboard', element: <Navigate to="/" replace /> },
      { path: 'contacts', Component: ContactList },
      { path: 'contacts/new', Component: ContactNew },
      { path: 'contacts/import', Component: ContactImport },
      { path: 'contacts/:id', Component: ContactDetail },
      { path: 'lists', Component: ListIndex },
      { path: 'lists/new', Component: ListNew },
      { path: 'lists/:id', Component: ListDetail },
      { path: 'layouts', Component: LayoutList },
      { path: 'layouts/new', Component: LayoutNew },
      { path: 'layouts/:id', Component: LayoutDetail },
      { path: 'templates', Component: TemplateList },
      { path: 'templates/new', Component: TemplateNew },
      { path: 'templates/:id', Component: TemplateDetail },
      { path: 'schedule', Component: ScheduleList },
      { path: 'schedule/new', Component: ScheduleNew },
      { path: 'schedule/:id', Component: ScheduleDetail },
      { path: 'send', Component: SendPage },
      { path: 'notifications', Component: Notifications },
      { path: 'communications', Component: CommunicationList },
      { path: 'communications/:id', Component: CommunicationDetail },
      { path: 'sends/:id', Component: SendDetail },
      { path: 'settings', Component: Settings },
      {
        Component: AdminRoute,
        children: [
          { path: 'inbound', Component: AdminInbound },
          { path: 'inbound/new', Component: AdminInboundNew },
          { path: 'inbound/:id', Component: AdminInboundDetail },
        ],
      },
      {
        path: 'admin',
        Component: AdminRoute,
        children: [
          { index: true, element: <Navigate to="/admin/integrations" replace /> },
          { path: 'integrations', Component: AdminIntegrations },
          { path: 'ai', Component: AdminAi },
          { path: 'senders', Component: AdminSenders },
          { path: 'senders/new', Component: AdminSenderNew },
          { path: 'senders/:id', Component: AdminSenderDetail },
          { path: 'imports', Component: AdminImports },
          { path: 'inbound', element: <Navigate to="/inbound" replace /> },
          { path: 'topics', Component: AdminTopics },
          { path: 'audits', Component: AdminAudits },
          { path: 'team', Component: AdminTeam },
          // Preview-only: the route always exists in the SPA but the
          // backing /api/captured-comms endpoint 404s outside preview
          // mode, so the page renders an empty list there.
          { path: 'captured-comms', Component: AdminCapturedComms },
        ],
      },
    ],
  },
])
